const images = [
   {
    imgURL:
      "https://m.media-amazon.com/images/I/71ROLBmB4AL._SX3000_.jpg",
    imgAlt: "img-4"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/61Yx5-N155L._SX3000_.jpg",
    imgAlt: "img-0"
  },
  
  {
    
    imgURL:
      "https://m.media-amazon.com/images/I/71xHyqBwdcL._SX3000_.jpg",
    imgAlt: "img-1"
  },
  {
    imgURL:
      "https://m.media-amazon.com/images/I/81hIlE5xocL._SX3000_.jpg",
    imgAlt: "img-2"
  },

 
  
];

export default images;
